import { render, staticRenderFns } from "./culture.vue?vue&type=template&id=4c4258af&scoped=true"
import script from "./culture.vue?vue&type=script&lang=js"
export * from "./culture.vue?vue&type=script&lang=js"
import style0 from "./culture.vue?vue&type=style&index=0&id=4c4258af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4258af",
  null
  
)

export default component.exports